<template>
  <modules-table :view="view"/>
</template>

<script>
import { mapState } from 'vuex'
import modulesTable from './table'

export default {
  components: {
    modulesTable
  },
  computed: {
    ...mapState('modules', {
      view: '_defaultView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/modules/all.vue